module.exports = __webpack_public_path__ + "img/features-03-image-02.bddfa6d7.png";